import React, { useState } from 'react'
import { Form, Input, message, Button } from 'antd'
import Clipboard from 'clipboard'
import { CopyOutlined } from '@ant-design/icons'
import axios from 'axios'
// Using ES6 import syntax
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark.min.css'

const { Search } = Input
const App = () => {
  const formRef = React.useRef(null)
  const inputRef = React.useRef(null)
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showCodeArea, setShowCodeArea] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])
  const onSearch = (value) => {
    // 手动触发表单验证
    formRef.current
      .validateFields(['str'])
      .then(() => {
        fetchData(value)
      })
      .catch((errorInfo) => {})
  }
  const fetchData = async (str) => {
    // 先清空原来的
    setResult('')
    setShowCodeArea(false)
    setIsLoading(true)
    try {
      const result = await axios.post(`html`, {
        url: str,
      })
      // 显示代码区域
      setShowCodeArea(true)
      const html = result.data.html
      setResult(html)
    } catch (error) {
      console.log(error)
      if (error.response.status === 500) {
        messageApi.open({
          type: 'error',
          content: '该网址访问不到',
        })
      }
    } finally {
      setIsLoading(false)
    }
  }
  const copyToClipboard = (text) => {
    const res = Clipboard.copy(text)
    if (res) {
      messageApi.open({
        type: 'success',
        content: '已复制',
      })
    }
  }
  return (
    <>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 16,
        }}
        autoComplete="off"
        initialValues={{
          str: 'http://www.it577.net',
        }}
      >
        <Form.Item
          label="网址"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入网址',
            },
            {
              pattern: new RegExp(
                '^(https?:\\/\\/)?' + // protocol
                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                  '(\\#[-a-z\\d_]*)?$',
                'i'
              ),
              message: '请输入正确的网址',
              validateFirst: true,
            },
          ]}
        >
          <Search
            ref={inputRef}
            onSearch={onSearch}
            enterButton
            loading={isLoading}
          />
        </Form.Item>
      </Form>
      {showCodeArea ? (
        <pre
          style={{
            textWrap: 'wrap',
            textAlign: 'left',
            background: '#282c33',
            color: '#b3b3b3',
            padding: '20px',
            borderRadius: '6px',
            position: 'relative',
          }}
        >
          <Button
            size='small'
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}
            icon={<CopyOutlined />}
            type="primary"
            onClick={() => copyToClipboard(result)}
          >
            复制源码
          </Button>
          <code
            dangerouslySetInnerHTML={{
              __html: hljs.highlight(result, {
                language: 'html',
              }).value,
            }}
          ></code>
        </pre>
      ) : (
        ''
      )}
      {contextHolder}
    </>
  )
}
export default App
